import { FunctionComponent, useState } from 'react'
import { Alert, Button, Form, Modal, Spinner } from 'react-bootstrap'

import Icon from 'components/ui/icon'
import * as userApi from 'features/user/api.client'
import { logout } from 'features/user/auth'
import { getApiErrorMessage } from '../apiError'
import AccountSection from './accountSection'
import accountCss from '../account.module.scss'

const CONFIRMATION_WORD = 'EXCLUIR'

/** Deletes the account and all its data on the backend, then signs out. */
const DeleteAccountSection: FunctionComponent = () => {
  const [confirming, setConfirming] = useState(false)
  const [typed, setTyped] = useState('')
  const [deleting, setDeleting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const close = () => {
    setConfirming(false)
    setTyped('')
    setError(null)
  }

  const deleteAccount = async () => {
    setDeleting(true)
    setError(null)

    try {
      await userApi.removeMe()
      logout()
      // Full reload so the app restarts in the signed-out state.
      window.location.href = '/login?accountRemoved=true'
    } catch (requestError) {
      setError(getApiErrorMessage(requestError, 'Erro ao excluir a conta.'))
      setDeleting(false)
    }
  }

  return (
    <AccountSection icon="trash" title="Excluir conta" danger className={accountCss.bottom}>
      <div className={accountCss.deleteRow}>
        <p className={accountCss.muted}>Seus dados serão removidos permanentemente.</p>
        <Button variant="danger" onClick={() => setConfirming(true)}>
          Excluir conta
        </Button>
      </div>

      <Modal show={confirming} onHide={close} centered>
        <Modal.Header closeButton>
          <Modal.Title>Excluir conta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <p className="text-muted">
            Sua conta e todos os seus dados serão apagados, inclusive os repasses.
            Esta ação não pode ser desfeita.
          </p>
          <Form.Group controlId="delete-account-confirmation">
            <Form.Label>
              Digite <strong>{CONFIRMATION_WORD}</strong> para confirmar
            </Form.Label>
            <Form.Control
              value={typed}
              autoComplete="off"
              onChange={(event) => setTyped(event.currentTarget.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={close}>
            Cancelar
          </Button>
          <Button
            variant="danger-solid"
            disabled={typed.trim().toUpperCase() !== CONFIRMATION_WORD || deleting}
            onClick={deleteAccount}
          >
            {deleting ? <Spinner size="sm" animation="border" /> : <Icon name="trash" />}
            Excluir conta
          </Button>
        </Modal.Footer>
      </Modal>
    </AccountSection>
  )
}

export default DeleteAccountSection
